import React from 'react';

const AdminSkeleton: React.FC = () => (
  <div className="animate-pulse space-y-4">
    <div className="h-64 rounded-xl bg-slate-100" />
  </div>
);

export default AdminSkeleton;
